<template>
  <ion-header >
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button defaultHref="/" @click="this.$router.push('/')"></ion-back-button>
      </ion-buttons>
      <div>
        <img class="quizlogoheader" src="../assets/salon26_logo_horizontal.png" alt="Logo Salon de la formation">
      </div>
    </ion-toolbar>
  </ion-header>
</template>

<script>

import {right} from "core-js/internals/array-reduce";
import {IonBackButton, IonButtons, IonToolbar, IonHeader} from "@ionic/vue";

export default {
  name: 'QuizHeader',
  methods: {right},
  components: {
    IonBackButton,
    IonButtons,
    IonToolbar,
    IonHeader
  }
}

</script>

<style scoped>
.quizlogoheader {
  height: 40px !important;
  text-align: right !important;
  margin: 0 !important;
}

div {
  display: flex;
  justify-content: end;
  padding: 10px;
}
</style>
